import type { Meta, StoryObj } from '@storybook/web-components';

import { createDocumentation, createComponent } from '@/globals/documentation/story';
import docs from './pn-level-up-docs.json';

const { argTypes, textContent } = createDocumentation(docs);

const meta: Meta<HTMLPnLevelUpElement> = {
  title: 'Components/Widgets/Level up',
  parameters: {
    actions: {
    },
    docs: {
      description: {
        story: textContent
      }
    }
  },
  args: {
    heading: 'Verify your address to find more packages',
    headingLevel: 'h2',
    preamble:'Level up your account with BankID.',
    imageUrl: 'https://picsum.photos/id/101/200/200',
    imageAltText: 'Alt Text',
    endpoint: 'https://se-integration.postnord.com',
    webModalContinueOtherDeviceLabel: 'Mobilt BankID',
    webModalContinueThisDeviceLabel: 'BankID på denna enhet',
    mobileModalContinueThisDeviceLabel: 'Öppna BankID',
    mobileModalContinueOtherDeviceLabel: 'BankID på en annan enhet',
    modalInstructionPhoneLineOne: 'Open your BankID app',
    modalInstructionPhoneLineTwo: 'Click on the QR button in the app',
    modalInstructionPhoneLineThree: 'Scan the QR code',
    modalHeadingText: 'Level up with BankID',
    modalOutdatedQRMessage: 'The QR has expired',
    modalExpiresInMessage: 'Expires in',
    qrAriaLabel: 'QR code for BankID',
    leveledupMessage: 'You have successfully leveled up!'
  },
  argTypes,
};

type Story = StoryObj<HTMLPnLevelUpElement>;

export default meta;

export const LevelUp: Story = {
  name: 'pn-level-up',
  render: (args) => createComponent('pn-level-up', args),
};

export const LevelUpLocalhost: Story = {
  name: 'levelup to localhost endpoints',
  render: LevelUp.render,args: {
    heading: 'Verify your address to find more packages',
    headingLevel: 'h2',
    preamble:'Level up your account with BankID.',
    imageUrl: 'https://picsum.photos/id/101/200/200',
    imageAltText: 'Alt Text',
    endpoint: 'https://localhost:51547',
    webModalContinueOtherDeviceLabel: 'Mobilt BankID',
    webModalContinueThisDeviceLabel: 'BankID på denna enhet',
    mobileModalContinueThisDeviceLabel: 'Öppna BankID',
    mobileModalContinueOtherDeviceLabel: 'BankID på en annan enhet',
    modalInstructionPhoneLineOne: 'Open your BankID app',
    modalInstructionPhoneLineTwo: 'Click on the QR button in the app',
    modalInstructionPhoneLineThree: 'Scan the QR code',
    modalHeadingText: 'Level up with BankID',
    modalOutdatedQRMessage: 'The QR has expired',
    modalExpiresInMessage: 'Expires in',
    qrAriaLabel: 'QR code for BankID',
    leveledupMessage: 'You have successfully leveled up!'
  }
};


export const AlreadyLeveledup: Story = {
  name: 'already leveled up',
  render: LevelUp.render,args: {
    heading: 'Verify your address to find more packages',
    headingLevel: 'h2',
    preamble:'Level up your account with BankID.',
    imageUrl: 'https://picsum.photos/id/101/200/200',
    imageAltText: 'Alt Text',
    endpoint: 'https://localhost:51547',
    webModalContinueOtherDeviceLabel: 'Mobilt BankID',
    webModalContinueThisDeviceLabel: 'BankID på denna enhet',
    mobileModalContinueThisDeviceLabel: 'Öppna BankID',
    mobileModalContinueOtherDeviceLabel: 'BankID på en annan enhet',
    modalInstructionPhoneLineOne: 'Open your BankID app',
    modalInstructionPhoneLineTwo: 'Click on the QR button in the app',
    modalInstructionPhoneLineThree: 'Scan the QR code',
    modalHeadingText: 'Level up with BankID',
    modalOutdatedQRMessage: 'The QR has expired',
    modalExpiresInMessage: 'Expires in',
    qrAriaLabel: 'QR code for BankID',
    leveledupMessage: 'You have successfully leveled up!',
    isLeveledUp: true
  }
};
